import { Outlet } from "react-router-dom";

export default function BillingLayout() {
    return (
        <Outlet />
    )
}